import { createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";
import { PublicClientApplication } from "@azure/msal-browser"; // Import MSAL
import { msalConfig } from "../auth/msalConfig"

const baseUrl = process.env.REACT_APP_BACKEND_BASE_URL;

const myApi = axios.create({
  baseURL: baseUrl,
  // headers: {
  //   "Content-Type": "application/json",
  // },
});

const msalInstance = new PublicClientApplication(msalConfig);

const initializeMsal = async () => {
  try {
    await msalInstance.initialize();
  } catch (error) {
    console.error("Error initializing MSAL:", error);
  }
};

const getAccessToken = async () => {
  try {
    await initializeMsal();
    const accounts = msalInstance?.getAllAccounts?.();
    const account = accounts ? accounts[0] : null;
    if (!account) {
      msalConfig.logoutRedirect({
        postLogoutRedirectUri: window.location.origin,
      });
      return null;
    }
    msalInstance?.setActiveAccount(account);
    const tokenRequest = {
      scopes: [`${process.env.REACT_APP_CLIENT_ID}/.default`],
    };
    const response = await msalInstance?.acquireTokenSilent(tokenRequest);
    return response?.accessToken;
  } catch (error) {
    console.error("Error acquiring token:", error);
    msalConfig.logoutRedirect({
      postLogoutRedirectUri: window.location.origin,
    });
    return null;
  }
};

export const createApi = (endpoint, method) => {
  return createAsyncThunk(
    `api/${endpoint}`,
    async ({ params, data, dynamicEndpoint, headers, contentType, responseType } = {}, { rejectWithValue }) => {
      try {
        const accessToken = await getAccessToken();
        const userEmail = localStorage.getItem("userEmail");
        if (!accessToken) {
          throw new Error("Failed to get access token");
        }

        const updatedParams = {
          ...params,
          userEmail,
        };

        const isFormData = data instanceof FormData;

        const response = await myApi({
          method,
          url: `${baseUrl}/${dynamicEndpoint || endpoint}`,
          params: updatedParams,
          data: method === "POST" || method === "PUT" || method === "DELETE" ? data : undefined,
          headers: {
            Authorization: `Bearer ${accessToken}`,
            ...(isFormData ? {} : { "Content-Type": "application/json" }),
            ...headers,
          },
          ...(responseType ? { responseType } : {})
        });

        return response?.data;
      } catch (error) {
        return rejectWithValue(error?.response?.data || error?.message);
      }
    }
  );
};